// format currency
import numeral from "numeral";
import moment from "moment";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function capitalise(str) {
  if (str && str.charAt(0)) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  } else {
    return str;
  }
}

// Format a currency string
export function parseCurrency(number, currency) {
  // Handle invalid inputs
  if (number === null || number === undefined || number === "") {
    return "-";
  }

  // Convert to number
  const numValue = parseFloat(number);

  // Check if conversion resulted in NaN
  if (isNaN(numValue)) {
    return "-";
  }

  // Determine format based on currency (JPY has no decimals)
  const currencyFormat = currency?.toLowerCase() === "jpy" ? "0,0" : "0,0.00";

  return numeral(numValue).format(currencyFormat);
}

// Format a date string (DD Mon YYYY)
export function parseDate(date) {
  return moment(date).format("DD MMM YYYY");
}

//

export function parseDateTime(date) {
  return moment.utc(date).local().format("YYYY-MM-DD HH:mm");
}

// Split the string to get only date before T
export function splitDate(date) {
  return date === "-" ? "-" : moment(date).format("DD MMM YYYY HH:mm");
}

// Format a time string (HH:MM)
export function parseTime(date) {
  return moment(date).format("HH:mm");
}

// Get today's date in string (YYYY-MM-DD)
export function getTodayDate() {
  return moment().format("YYYY-MM-DD");
}

export function getDaysBefore(days) {
  return moment().subtract(days, "days").format("YYYY-MM-DD");
}

export function getCurrentMonYear() {
  return moment().format("MMM YYYY");
}

// Parse user's email to get username
export const parseEmail = (emailStr) => {
  var name = emailStr.split("@")[0];
  if (name.includes(".")) {
    name.replace(".", " ");
  }

  return capitalise(name);
};

// Remove '_' symbol and capitalise a brand name
export const parseBrandName = (brand) => {
  return brand;
};

export function percentageFormat(num) {
  return parseFloat(num).toFixed(2) + " %";
}

// Parse values into JSON.stringify
export function stringifyValues(object) {
  let output = {};
  for (const [key, value] of Object.entries(object)) {
    if (value && Array.isArray(value)) {
      output[key] = JSON.stringify(value);
    } else output[key] = value;
  }
  return output;
}

// get date from last Monday
export function getMonday() {
  if (moment().day() === 1) {
    return moment();
  }
  return moment().isoWeekday(1);
}

export function formatDateFilter(date, time) {
  const calendarDate = moment.isMoment(date) || moment.isDate(date)
    ? moment(date).format("YYYY-MM-DD")
    : date;
  const value = moment.utc(calendarDate, "YYYY-MM-DD");

  return time === "start"
    ? value.startOf("day").format()
    : value.endOf("day").format();
}

export function utcToBrowserTimeZone(date) {
  return moment.utc(date).local().format("YYYY-MM-DD HH:mm");
}

//! GW2 Related Functions
export function parseNumberWithComma(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function applySortFilter(array, sortOrder, orderBy, query) {
  let newArray = [...array];

  if (orderBy) {
    newArray.sort((a, b) => {
      if ((a[orderBy] ?? '') !== '' && (b[orderBy] ?? '') !== '') {
        if (typeof a[orderBy] === 'boolean' && typeof b[orderBy] === 'boolean') {
          if (sortOrder === "asc") {
            return a[orderBy] - b[orderBy];
          } else if (sortOrder === "desc") {
            return b[orderBy] - a[orderBy];
          }
        } else {
          if (sortOrder === "asc") {
            return a[orderBy].toString().localeCompare(b[orderBy].toString());
          } else if (sortOrder === "desc") {
            return b[orderBy].toString().localeCompare(a[orderBy].toString());
          }
        }
      }

      if (!a[orderBy]) return 1;
      if (!b[orderBy]) return -1;

      return 0;
    });
  }

  if (query) {
    return newArray.filter((value) => {
      return value.email.toLowerCase().startsWith(query.toLowerCase());
    });
  }

  return newArray;
}

// function applySortFilter(array, comparator, query) {
//   query = query.toLowerCase();
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   if (query) {
//     return array.filter((value) => {
//       return (
//         value.name.toLowerCase().startsWith(query) ||
//         value.mid.toLowerCase().startsWith(query)
//       );
//     });
//   }
//   return stabilizedThis.map((el) => el[0]);
// }

export function mapShopeePayPaymentChannel(paymentChannelCode) {
  // Handle null, undefined, empty string, or invalid values
  if (paymentChannelCode === null || paymentChannelCode === undefined || paymentChannelCode === "") {
    return "-";
  }

  const channelMap = {
    WALLET: "Wallet",
    CREDIT: "Credit Card / Debit Card",
    CCCD: "Credit Card / Debit Card",
    BANK: "Bank Account",
    SPAYLATER: "SPayLater",
  };

  const key = paymentChannelCode.toString().toUpperCase();
  return channelMap[key] || `Unknown (${paymentChannelCode})`;
}

// true when a search form holds no usable criteria, so the list pages can fall
// back to the default filter they used to query with on page load
export function isEmptyFilter(filterParams) {
  if (!filterParams) return true;

  return Object.values(filterParams).every(
    (value) =>
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (Array.isArray(value) && value.length === 0)
  );
}
